import React from 'react';
import { tr } from '../i18n';
import ForbiddenState from '../ui/system-states/ForbiddenState';
import LoginGateState from '../ui/system-states/LoginGateState';

type Props = {
  authenticated: boolean;
  admin: boolean;
  children: React.ReactElement;
};

const RequireAdmin: React.FC<Props> = ({ authenticated, admin, children }) => {
  if (!authenticated) {
    return (
      <LoginGateState
        title={tr.shell.auth.loginRequiredTitle}
        description={tr.shell.auth.adminLoginDescription}
      />
    );
  }
  if (!admin) {
    return (
      <ForbiddenState
        title={tr.shell.auth.adminOnlyTitle}
        description={tr.shell.auth.adminOnlyDescription}
        actions={[{ label: tr.common.actions.toHome, href: '/', variant: 'outline' }]}
      />
    );
  }
  return children;
};

export default RequireAdmin;
